module.exports = __webpack_public_path__ + "fonts/remixicon.9915fef9.woff2";